/* eslint-disable max-len */
import React from 'react';
import { resolve } from '@leverege/plugin';
import { Button, Dialogs, Flex, Pane, Text } from '@leverege/ui-elements';
import { Toolbar, TitleBar } from '@leverege/ui-plugin';
import { GlobalState, UI } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { connect } from 'react-redux';
import { History } from '@leverege/molten-core';
import StackOverlay from "./StackOverlay.js";
import ToolbarFactory from "./ToolbarFactory.js";
import useStack from "./useStack.js";
import S from './ShowMainNav.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.screens.main.ShowMainNav');
const navMatchContext = {
  use: 'navBar',
  client: 'Main'
};
const userMatchContext = {
  use: 'userBar',
  client: 'Main'
};
const footerMatchContext = {
  use: 'footerBar',
  client: 'Main'
};
const onHome = () => {
  GlobalState.dispatch(History.push('/'));
};
function Root({
  stack,
  context,
  navIconOverride,
  navTitleVariantOverride
}) {
  const navFactory = new ToolbarFactory({
    variant: 'mobileTopNavBar|mobileNavBar',
    vertical: true,
    matchContext: navMatchContext,
    stack
  });
  const userFactory = new ToolbarFactory({
    variant: 'mobileUserNavBar|mobileNavBar',
    vertical: true,
    matchContext: userMatchContext,
    stack
  });
  const footerFactory = new ToolbarFactory({
    variant: 'mobileFooterNavBar|mobileNavBar',
    vertical: true,
    matchContext: footerMatchContext,
    stack
  });
  const showNav = stack.isEmpty() || stack.top().matchContext === navMatchContext;
  const showUser = stack.isEmpty() || stack.top().matchContext === userMatchContext;
  const showFooter = stack.isEmpty() || stack.top().matchContext === footerMatchContext;
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "col",
    className: S.flex,
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "col",
      className: S.top,
      children: [stack.isEmpty() && /*#__PURE__*/_jsx(TitleBar, {
        variant: "mobileMainNavTitle|mobileNavTitle",
        titleVariant: navTitleVariantOverride,
        icon: navIconOverride,
        onClick: onHome
      }), !stack.isEmpty() && /*#__PURE__*/_jsx(TitleBar, {
        variant: "mobileMainNavTitle|mobileNavTitle",
        children: /*#__PURE__*/_jsx(Button, {
          variant: "mobileNavBack",
          onClick: stack.pop,
          children: t('back')
        })
      }), !stack.isEmpty() && /*#__PURE__*/_jsxs(Flex, {
        variant: "col",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "mobileNavSubtitle",
          icon: resolve(stack.top().icon),
          disabled: true,
          children: resolve(stack.top().name)
        }), /*#__PURE__*/_jsx(Pane, {
          className: S.divider
        })]
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "col",
      className: S.middle,
      children: [showNav && /*#__PURE__*/_jsx(Pane, {
        layout: "flex:colM",
        variant: "mobileTopNav",
        className: S.mobileTopNav,
        children: /*#__PURE__*/_jsx(Toolbar, {
          vertical: true,
          factory: navFactory,
          variant: "mobileTopNavBar|mobileNavBar",
          matchContext: navMatchContext,
          context: context
        })
      }), showNav && showUser && /*#__PURE__*/_jsx(Pane, {
        className: S.divider
      }), showUser && /*#__PURE__*/_jsx(Pane, {
        layout: "flex:colM",
        variant: "mobileUserNav",
        className: S.mobileUserNav,
        children: /*#__PURE__*/_jsx(Toolbar, {
          vertical: true,
          factory: userFactory,
          variant: "mobileUserNavBar|mobileNavBar",
          matchContext: userMatchContext,
          context: context
        })
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      variant: "col",
      className: S.bottom,
      children: showFooter && /*#__PURE__*/_jsx(Pane, {
        layout: "flex:colM",
        variant: "mobileFooterNav",
        className: S.mobileFooterNav,
        children: /*#__PURE__*/_jsx(Toolbar, {
          vertical: true,
          factory: footerFactory,
          variant: "mobileFooterNavBar|mobileNavBar",
          matchContext: footerMatchContext,
          context: context
        })
      })
    })]
  });
}
function showOverlay(cxt) {
  Dialogs.show({
    component: connect(state => {
      return {
        navIconOverride: UI.get(state, 'molten.mobileNavIconOverride'),
        navTitleVariantOverride: UI.get(state, 'molten.mobileNavTitleVariantOverride') || 'mobileNavLogo'
      };
      // eslint-disable-next-line prefer-arrow-callback
    })(function ShowOverlayComponent({
      show,
      onClose,
      navIconOverride,
      navTitleVariantOverride
    }) {
      const stack = useStack();
      const renderer = stack => {
        return /*#__PURE__*/_jsx(Pane, {
          variant: "mobileMainNav",
          className: S.hidden,
          children: /*#__PURE__*/_jsx(Root, {
            stack: stack,
            navTitleVariantOverride: navTitleVariantOverride,
            navIconOverride: navIconOverride,
            context: {
              ...cxt,
              show,
              onClose
            }
          })
        });
      };
      return /*#__PURE__*/_jsx(StackOverlay, {
        mode: "dual",
        stack: stack,
        renderer: renderer,
        show: show,
        onClose: onClose,
        position: "left",
        animation: "slideFromLeft"
      });
    }),
    id: 'mobileTopNav'
  });
}
export default {
  id: 'molten.screens.main.ShowMainNav',
  name: tf('name'),
  // visible in all group screens
  matches: {
    use: 'navActions',
    client: 'Main'
  },
  handles: () => true,
  customComponent: ({
    context
  }) => {
    // TODO : move icon to config
    return /*#__PURE__*/_jsx(Button, {
      icon: tIcon('icon', 'fa fa-bars fa-fw'),
      variant: "mobileActionBar|actionBar",
      style: {
        zIndex: 10
      },
      onClick: () => showOverlay(context)
    });
  }
};